import { Box, styled } from '@material-ui/core';

export const VideoLinkRow = styled(Box)({
  display: 'flex',
  alignItems: 'flex-start',
});
